// extracted by mini-css-extract-plugin
export var activeNavLink = "NewTogglerModal-module--activeNavLink--Oohz-";
export var contactBtn = "NewTogglerModal-module--contactBtn--oqXRg";
export var ctaSection = "NewTogglerModal-module--ctaSection--y-5hy";
export var logoImage = "NewTogglerModal-module--logoImage--Rb52+";
export var menuContent = "NewTogglerModal-module--menuContent--cXhSA";
export var modalBody = "NewTogglerModal-module--modalBody--C5J7h";
export var modalDialog = "NewTogglerModal-module--modalDialog--KwJ58";
export var modalHeader = "NewTogglerModal-module--modalHeader--i8v0j";
export var modalLogo = "NewTogglerModal-module--modalLogo--vvqtn";
export var navLink = "NewTogglerModal-module--navLink--5m6Ay";
export var navList = "NewTogglerModal-module--navList--hkip+";